import HeroBackgroundPage from '@/components/templates/HeroBackgroundPage';
import { CREATOR_APPLICATION_BACKGROUND, CREATOR_APPLICATION_BACKGROUND_OPACITY } from '@/constants/creatorApplication';
import usePublicContentCreatorApplicationMe from '@/hooks/contentcreator/usePublicContentCreatorApplicationMe';
import ContentCreatorApplicationPublicHero from '@/modules/contentCreator/ContentCreatorApplicationPublicHero';
import { createFileRoute, redirect } from '@tanstack/react-router';

type ContentCreatorApplicationPublicSearch = {
  email: string;
};

const ContentCreatorApplicationPublicRoute = () => {
  const { token } = Route.useParams();
  const { email } = Route.useSearch();
  const { application, isError, isFetching, isLoading } = usePublicContentCreatorApplicationMe({ email, token });

  return (
    <HeroBackgroundPage
      heroChildren={
        <ContentCreatorApplicationPublicHero
          email={email}
          token={token}
          application={application}
          isApplicationError={isError}
          isApplicationLoading={isLoading || isFetching}
        />
      }
      backgroundOverlay={CREATOR_APPLICATION_BACKGROUND}
      backgroundOverlayOpacity={CREATOR_APPLICATION_BACKGROUND_OPACITY}
      isBackgroundFixed
    />
  );
};

export const Route = createFileRoute('/content-creator/application/public/$token')({
  staticData: { title: 'Creator Application' },
  component: ContentCreatorApplicationPublicRoute,
  validateSearch: (search: Record<string, unknown>): ContentCreatorApplicationPublicSearch => ({
    email: typeof search.email === 'string' ? search.email : '',
  }),
  beforeLoad: async ({ search }) => {
    if (!search.email) {
      throw redirect({ to: '/creator/apply/form' });
    }
  },
});
